import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a23418a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "title ft-w-6"
}
const _hoisted_3 = {
  key: 1,
  class: "title ft-w-6"
}

import { t } from '@/plugins/i18n'
import { ref, watch, computed, reactive } from 'vue'
import { useStore } from 'vuex'
import { authAmazon } from '@/util/useAuthShop'
import { isD2C, isJA, isKO } from '@/store'
import AmazonAgreement from '../static/AmazonAgreement.vue'
import ShopGuide from '@/components/guide/ShopGuide.vue'
import { QuestionFilled } from '@element-plus/icons-vue'
import CreateShopItem from './CreateShopItem.vue'
import { Site } from '@/common/const'

export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'shopData'],
  emits: ['close', 'ok', 'listen'],
  setup(__props, { emit }) {

const props = __props


const shopData = computed(() => props.shopData)
const isCreate = computed(() => !props.shopData) // 没有值就是创建店铺
const store = useStore()

const model: any = reactive({})
const trigger: any = ref(null)

// d2c
const getCurrentShopd2c = () => {
  if (isJA()) {
    return 1
  } else {
    return 0
  }
}

// b2b
const getCurrentShopb2b = () => {
  if (isJA()) {
    return 4
  } else {
    return 0
  }
}

watch(
  shopData,
  (data) => {
    Object.keys(model).forEach((k) => {
      delete model[k]
    })
    if (data) {
      Object.entries(data).forEach(([k, v]) => {
        model[k] = v
      })
    } else {
      // 2023-7-13 不对接Shopify。之前只有d2c有Shopify。但是这个data model只有亚马逊使用了。所以不改
      const data = {
        customerShopPlatform: isD2C() ? getCurrentShopd2c() : getCurrentShopb2b(),
        customerShopPlatName: '',
        customerShopLogo: '',
        customerShopName: '',
        customerShopUrl: '',
        customerShopKey: '',
        accessToken: ''
      }
      Object.entries(data).forEach(([k, v]) => {
        if (['customerShopAuthStatus'].includes(k)) return
        model[k] = v
      })
    }
  },
  { immediate: true }
)

const shopGuideModalVisible = ref(false)
const shopsList = computed(() => store.getters.userShops)
const closeModal = () => {
  shopGuideModalVisible.value = !shopGuideModalVisible.value
}
// 日本站没有店铺弹出引导
shopsList.value.length === 0 && !isKO() && (shopGuideModalVisible.value = true)

const authAmazonFn = () => {
  trigger.value = () => {
    authAmazon(model)
    trigger.value = null
    emit('close')
    emit('listen')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, _mergeProps({ "model-value": __props.visible }, _ctx.$attrs, {
    width: "980px",
    onClosed: _cache[5] || (_cache[5] = ($event: any) => (emit('close'))),
    "close-on-click-modal": false,
    "destroy-on-close": true
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(isCreate))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(_unref(t)('创建店铺')) + " ", 1),
              (!_unref(isKO)())
                ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 0,
                    class: "icon",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (shopGuideModalVisible.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(QuestionFilled))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)('修改店铺信息')), 1)),
        _createVNode(CreateShopItem, {
          onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close'))),
          onOk: _cache[2] || (_cache[2] = ($event: any) => (emit('ok'))),
          onListen: _cache[3] || (_cache[3] = ($event: any) => (emit('listen'))),
          shopData: props.shopData,
          onAuthAmazon: authAmazonFn
        }, null, 8, ["shopData"]),
        (trigger.value)
          ? (_openBlock(), _createBlock(AmazonAgreement, {
              key: 2,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (trigger.value = null)),
              onOk: trigger.value
            }, null, 8, ["onOk"]))
          : _createCommentVNode("", true),
        (shopGuideModalVisible.value)
          ? (_openBlock(), _createBlock(ShopGuide, {
              key: 3,
              onClose: closeModal
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 16, ["model-value"]))
}
}

})